module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<!--<div *ngIf=\"auth.authState | async as user; else showLogin\">\n  <h1>Hello {{ user.displayName }}!</h1>\n  <button (click)=\"logout()\">Logout</button>\n</div>\n\n<ng-template #showLogin>\n  <app-login></app-login>\n</ng-template>-->\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main